import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { PersonImage } from 'signin-app/components/person-image';
import PersonSelect from 'signin-app/components/person-select';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import * as GroupsSelectors from 'signin-app/groups/selectors';
import * as ChildSelectors from 'signin-app/child/selectors';
import translate from 'signin-app/helpers/translate';
import { getInitials } from 'signin-app/util/get-initials';
import * as PinSelectors from 'signin-app/pin/selectors';
import * as Selectors from './selectors';
import { CheckOutSubmit } from './checkout-submit';
import { useCheckOutChild } from './check-out-child-context';
const DetailsRow = ({ start, end }) => {
    return (_jsxs(Box, { children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", color: "n400", p: 6, minHeight: "112px", boxSizing: "border-box", children: [_jsx(Text, { variant: "h6", children: start }), _jsx(Box, { children: end })] }), _jsx(Box, { height: "1px", backgroundColor: "n100", width: "100%" })] }));
};
const PickupPerson = ({ image, name }) => {
    return (_jsxs(Stack, { alignItems: "center", gap: 2, children: [image && _jsx(PersonImage, { size: "sm", image: image, initials: getInitials(name) }), _jsx(Text, { variant: "h5", emphasized: true, children: name })] }));
};
const PickupRoom = ({ image, title }) => {
    const initials = React.useMemo(() => {
        const firstTwoWordsOfTitle = title.split(' ').slice(0, 2).join(' ');
        return getInitials(firstTwoWordsOfTitle);
    }, [title]);
    return (_jsxs(Stack, { alignItems: "center", gap: 2, children: [_jsx(PersonImage, { size: "sm", image: image, initials: initials }), _jsx(Text, { variant: "h5", emphasized: true, children: title })] }));
};
export const CheckOutDetails = (props) => {
    const { child } = useCheckOutChild();
    const { showSwitchRoomView } = props;
    const pickupTime = useTypedSelector(state => Selectors.pickupTime(state, { child }));
    const groups = useTypedSelector(GroupsSelectors.groups);
    const goHomeWithChild = useTypedSelector(state => PinSelectors.goHomeWithChild(state, { childId: child.id }));
    const currentChildGroupId = useTypedSelector(state => ChildSelectors.currentChildGroupId(state, { id: child.id }));
    const room = React.useMemo(() => {
        var _a;
        const currentGroup = (_a = groups.find(g => g.groupId === currentChildGroupId)) !== null && _a !== void 0 ? _a : groups.find(g => g.groupId === child.groupId);
        if (!currentGroup) {
            return null;
        }
        return { title: currentGroup.title, image: currentGroup.image.small };
    }, [groups, currentChildGroupId, child.groupId]);
    const { pickupName, pickupImage } = useTypedSelector(state => {
        const pickupName = Selectors.pickupFullName(state, {
            child,
        });
        const pickupImage = Selectors.pickupImage(state, {
            child,
        });
        return { pickupName, pickupImage };
    });
    return (_jsxs(_Fragment, { children: [_jsx(PersonSelect, { activeChildId: child.id }), _jsxs(Stack, { direction: "column", width: "100%", mx: "auto", maxWidth: "568px", gap: 1, children: [pickupName && (_jsx(DetailsRow, { start: goHomeWithChild ? translate('goingHomeWith') : translate('checkoutPickedUpBy'), end: _jsx(PickupPerson, { name: pickupName, image: pickupImage }) })), pickupTime && (_jsx(DetailsRow, { start: translate('checkoutPickupTime'), end: _jsx(Text, { variant: "h5", emphasized: true, children: pickupTime }) })), room && (_jsx(DetailsRow, { start: translate('checkoutPickupFrom'), end: room && _jsx(PickupRoom, { image: room.image, title: room.title }) }))] }), _jsx(CheckOutSubmit, { showSwitchRoomView: showSwitchRoomView })] }));
};
